import { HttpContextToken } from '@angular/common/http';

export const ContextKey = {
  ApiEncryption: new HttpContextToken<boolean>(() => true),
  ApiVersion: new HttpContextToken<string>(() => '2.0'),
};
